// extracted by mini-css-extract-plugin
module.exports = {"progress":"UserProgressBar_progress__dhfc5"};